import { render } from "./DashboardSpaceSimulations.vue?vue&type=template&id=30f7b15f&scoped=true"
import script from "./DashboardSpaceSimulations.vue?vue&type=script&lang=js"
export * from "./DashboardSpaceSimulations.vue?vue&type=script&lang=js"

import "./DashboardSpaceSimulations.vue?vue&type=style&index=0&id=30f7b15f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30f7b15f"

export default script